<script lang="ts" setup>
const guards = useGuards()
const enrichmentStore = useEnrichmentStore()
const { toggleModal } = useOverlays()

// Template refs
const inputRef = useTemplateRef<HTMLInputElement>('inputRef')

// Methods
async function handleFileSelect(event: Event) {
  const input = event.target as HTMLInputElement

  // File dialog closed with selection
  enrichmentStore.isSelectingFile = false

  await guards.awaitUser({
    onClose: () => {
      enrichmentStore.reset()
    },
    onSuccess: () => {
      if (input.files && input.files.length > 0) {
        const file = enrichmentStore.handleFileDrop(input.files)

        if (file) {
          toggleModal({
            opened: true,
            type: 'listEnrichment',
          })
          enrichmentStore.initializing = true
        }
      }
    },
  })
}

// Track file dialog opening
function openFileDialog() {
  enrichmentStore.isSelectingFile = true

  // Add document click listener to detect when dialog closes
  const handleDocumentClick = () => {
    enrichmentStore.isSelectingFile = false
    document.removeEventListener('click', handleDocumentClick)
  }

  // Delay adding the event listener to avoid catching the current click
  setTimeout(() => document.addEventListener('click', handleDocumentClick, { once: true }), 100)
}

// Set input target in enrichment store
watch(
  () => inputRef.value,
  value => value && (enrichmentStore.fileInputRef = value),
  { immediate: true },
)
</script>

<template>
  <div>
    <input
      :key="enrichmentStore.fileInputKey"
      ref="inputRef"
      :accept="enrichmentStore.acceptedFormats.join(', ')"
      class="hidden"
      type="file"
      @change="handleFileSelect"
      @click="openFileDialog"
    >
  </div>
</template>
